"use client"

import MediaComponent from "@core/helpers/client/components/media-component"

const ImageComponent = ({placeholder_src, ...props}) => {
	return (
		<MediaComponent
			{...props}
			placeholder_src={placeholder_src || "/images/placeholders/image.png"}
			placeholder_width={100}
			placeholder_height={100}
		/>
	)
}
export default ImageComponent